export default function({ dispatch, commit }, data) {
    commit('startedAuthentication')

    // POST /auth/login
    return dispatch('post', {
        url: '/auth/invite/verify',
        data
    }, {
        root: true
    })
    .then((result) => {
        commit('finishedAuthentication')
        commit('validatedInviteToken', result)
        return result
    })
    .catch((error) => {
        commit('finishedAuthentication')
        throw error
    })
}
